<template>
  <div class="body">
    <!-- 添加/编辑-option： -->
    <div class="title">{{ isAdd ? $t('message.createOptionDescription') : $t('message.editOptionDescription') }}</div>
    <div class="content">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="demo-ruleForm">
        <!-- 排序 -->
        <el-form-item :label="$t('message.sort')" prop="sort">
          <el-input v-model="ruleForm.sort" style="width: 100px;"></el-input>
          <span style="color: #c35257;">*数字越大越靠前</span>
        </el-form-item>
        <!-- 类目 -->
        <el-form-item :label="$t('message.majorCategory')" prop="category_id">
          <el-select v-model="ruleForm.category_id" placeholder="请选择">
            <el-option v-for="item in tableData" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 状态 -->
        <el-form-item :label="$t('message.status')">
          <el-switch v-model="ruleForm.status_type">
          </el-switch>
        </el-form-item>
        <!-- 项目名称 -->
        <el-form-item :label="$t('message.projectName')" prop="name">
          <el-input v-model="ruleForm.name" type="textarea"></el-input>
        </el-form-item>
        <!-- 问号图标说明 -->
        <el-form-item :label="$t('message.questionMarkIconDescription')" prop="icon_desc">
          <quill-editor ref="myTextEditor" id="quill-editor" v-model="ruleForm.icon_desc" :options="quillOption">
          </quill-editor>
        </el-form-item>
        <!-- 页面固定展示说明 -->
        <el-form-item :label="$t('message.pageFixedDisplayDescription')" prop="fixed_desc">
          <quill-editor ref="myTextEditor" id="quill-editor" v-model="ruleForm.fixed_desc" :options="quillOption">
          </quill-editor>
        </el-form-item>
        <!-- 普通会员收费说明 -->
        <el-form-item :label="$t('message.regularMemberFeeDescription')" prop="normal_client_desc">
          <quill-editor ref="myTextEditor" id="quill-editor" v-model="ruleForm.normal_client_desc"
            :options="quillOption">
          </quill-editor>
        </el-form-item>
        <!-- 定额会员收费说明 -->
        <el-form-item :label="$t('message.fixedRateMemberFeeDescription')" prop="vip_client_desc">
          <quill-editor ref="myTextEditor" id="quill-editor" v-model="ruleForm.vip_client_desc" :options="quillOption">
          </quill-editor>
        </el-form-item>
        <!-- SVIP收费说明 -->
        <el-form-item :label="$t('message.svipFeeDescription')" prop="svip_client_desc">
          <quill-editor ref="myTextEditor" id="quill-editor" v-model="ruleForm.svip_client_desc" :options="quillOption">
          </quill-editor>
        </el-form-item>
        <!-- SVIP收费说明 -->
        <el-form-item :label="$t('message.svipFeeDescription')" prop="svip_client_desc">
          <quill-editor ref="myTextEditor" id="quill-editor" v-model="ruleForm.svip_client_desc" :options="quillOption">
          </quill-editor>
        </el-form-item>
        <!-- option图片 -->
        <!-- option图片 -->

        <el-form-item :label="$t('message.optionImage')">
          <div style="display: flex;">
            <el-upload class="upload-demo" ref="upload" action="https://jsonplaceholder.typicode.com/posts/"
              :before-upload="befoUpload" :show-file-list="false" :http-request="httpupPic">
              <el-image style="width:128px;height: 72px;;border-radius: 6px; " :src="ruleForm.option_pic"
                v-if="ruleForm.option_pic">
              </el-image>
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <span style="color: #c35257;">*图片只能传一张</span>
          </div>
        </el-form-item>
        <!-- option视频 -->
        <el-form-item :label="$t('message.optionVideo')">
          <el-input v-model="ruleForm.option_video"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="btn">
      <!--取 消  -->
      <el-button @click="$parent.iSoptionStore = false">
        {{ $t("message.cancel") }}</el-button>
      <!-- 保存 -->
      <el-button type="primary" @click="optionDescOptionStore" v-if="isAdd">
        {{ $t("message.ok") }}
      </el-button>
      <!-- 保存 -->
      <el-button type="primary" @click="optionDescOptionUpdate" v-else>
        {{ $t("message.ok") }}
      </el-button>
    </div>
  </div>
</template>
<script>
import { quillEditor } from "vue-quill-editor";
import quillConfig from "@/utlis/quill-config";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
export default {
  components: {
    quillEditor
  },
  props: {
    isAdd: { type: Boolean },
    tableData: { type: Array },
  },
  data() {
    return {
      quillOption: quillConfig,
      ruleForm: {
      },
      dialogVisible: false,
      rules: {
        category_id: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],
        name: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],

        sort: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },

        ],
        normal_client_desc: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],
        vip_client_desc: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],
        svip_client_desc: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ]
      },
    };
  },
  methods: {
    // 新增
    optionDescOptionStore() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.ruleForm.status = this.ruleForm.status_type ? 1 : 0
          this.$api.siteConfiguration.optionDescOptionStore(this.ruleForm).then((res) => {
            this.$message.success(res.msg);
            this.$parent.iSoptionStore = false
            this.$parent.optionDescList()
          });
        }
      })
    },
    // 修改
    optionDescOptionUpdate() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.ruleForm.status = this.ruleForm.status_type ? 1 : 0
          this.$api.siteConfiguration.optionDescOptionUpdate(this.ruleForm).then((res) => {
            this.$message.success(res.msg);
            this.$parent.iSoptionStore = false
            this.$parent.optionDescList()
          });
        }
      })
    },
    acceptData(data) {
      this.ruleForm = data
      this.dialogVisible = true
    },
    befoUpload(file) {
      const isPic =
        ["image/jpeg", "image/png", "image/jpg"].indexOf(file.type) != -1;
      if (!isPic) {
        if (file.name.indexOf('HEIC') == -1) {
          this.$message.error("请上传图片");
          return false
        }
      }
      return isPic;
    },
    // 主图上传
    async httpupPic(file) {
      let data = await this.createClient(file)
      this.ruleForm.option_pic = data.data
      this.$forceUpdate()
    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px;
}

/deep/.ql-editor {
  min-height: 300px !important;
}

.btn {
  text-align: center;
}

.avatar-uploader-icon {
  display: flex;
  width: 126px;
  height: 72px;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  border: 1px dashed #ccc;
}
</style>